var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"create"}},[_c('container',{attrs:{"textButton":"voltar","pathName":_vm.path,"pathIcone":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }